import { render, staticRenderFns } from "./OfficeShopSignage.vue?vue&type=template&id=29905d98&scoped=true&"
import script from "./OfficeShopSignage.vue?vue&type=script&lang=ts&"
export * from "./OfficeShopSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29905d98",
  null
  
)

export default component.exports